// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__BBCN0 { font-size: 20px; font-weight: bold; padding: 10px; }`, "",{"version":3,"sources":["webpack://./src/modules/Manager/FinStatisticV2/components/Header.module.css"],"names":[],"mappings":"AAAA,wBAAU,eAAe,EAAE,iBAAiB,EAAE,aAAa,EAAE","sourcesContent":[".header { font-size: 20px; font-weight: bold; padding: 10px; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__BBCN0`
};
export default ___CSS_LOADER_EXPORT___;
